export const NAVBAR_SECTION_WIDTH = {
  FULL: 'full',
  HALF: 'half',
};
